/**
 * Loading Directive
 * @see http://tobiasahlin.com/spinkit/
 */
// import "./up-loading.scss";

angular.module("UP").directive("upLoading", rdLoading);

function rdLoading() {
  var directive = {
    restrict: "AE",
    template:
      '<div class="up-loading"><div class="double-bounce1"></div><div class="double-bounce2"></div></div>',
  };
  return directive;
}
